import { useSuspenseQuery } from '@tanstack/react-query';
import { dashboardQueries } from '../queries/dashboardQueries';
import {
  DASHBOARD_SUBSCRIPTION_STATUS,
  getDashboardSubscriptionStatus,
  RGUFilter,
} from '../api/DashboardApi';
import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { getPieColors } from 'src/common/components/Graphs/common/Graphs/utils/doughnut';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';

type UseSubscriptionStatusDataProps = {
  accountRef: string;
  rguFilter?: RGUFilter;
};

export const useSubscriptionStatusData = ({
  accountRef,
  rguFilter,
}: UseSubscriptionStatusDataProps) => {
  const { palette } = useTheme();
  const { t } = useTranslation();

  const { data } = useSuspenseQuery({
    queryKey: dashboardQueries.subscriptionStatus({ accountRef, rguFilter }),
    queryFn: () => setMinimalPromiseTime(getDashboardSubscriptionStatus({ accountRef, rguFilter })),
  });

  const subscriptionStatusData = useMemo(
    () => ({
      labels: [
        t('dashboard.subscriptionsStatusChart.legend.test'),
        t('dashboard.subscriptionsStatusChart.legend.active'),
        t('dashboard.subscriptionsStatusChart.legend.deactivated'),
      ],
      dataset: {
        data: [
          data.data[DASHBOARD_SUBSCRIPTION_STATUS.TEST],
          data.data[DASHBOARD_SUBSCRIPTION_STATUS.ACTIVE],
          data.data[DASHBOARD_SUBSCRIPTION_STATUS.DEACTIVATED],
        ],
        ...getPieColors([palette.blue, palette.green, palette.red]),
      },
    }),
    [t, data],
  );

  return { chartData: subscriptionStatusData, total: data.total };
};
